import { html } from 'lit';
import { createElement, Unlock } from 'lucide';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-unlock')
export class PdsIconUnlock extends PdsIcon {
  createIconElement(): SVGElement {
    return createElement(Unlock);
  }

  render() {
    return html`${this.icon}`;
  }
}
